import React from 'react'

import './stack.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

export type Spacings =
  | '0'
  | '60'
  | '70'
  | '80'
  | '90'
  | '100'
  | '200'
  | '300'
  | '400'
  | '500'
  | '600'
  | '700'
  | '800'
  | '900'
  | '1000'
  | '1100'
  | '1200'
  | '1300'
  | '1400'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children?: React.ReactNode
    /** Accepts all CCDS spacings values */
    space?: Spacings
    /** Overrides space for tablet screen sizes */
    spaceM?: Spacings
    /** Overrides space for desktop screen sizes */
    spaceL?: Spacings
  }
>

/**
 * The props **space**, **spaceM** and **spaceL** accept all CCDS spacings values ('60', '70', ..., '1400').
 *
 * Use **spaceM** and **spaceL** to add a responsive behaviour (tablet and desktop).
 */
const Stack = ({className, children, space = '100', spaceM, spaceL, ...props}: Props) => (
  <div
    {...props}
    className={cn(
      'Stack',
      {[`space-${space}`]: !!space, [`spaceM-${spaceM}`]: !!spaceM, [`spaceL-${spaceL}`]: !!spaceL},
      className
    )}
  >
    {children}
  </div>
)

export default Stack
